export default __webpack_public_path__ + "static/media/invention.cdb2c280.png";